import { component as defineComponent } from 'flightjs';

function FormChangeTracker() {
    var isDirty = false;

    this.attributes({
        inputSelector: 'input, textarea, select',
        submitSelector: 'input[type="submit"], button[type="submit"]',
        exitMessage: 'You have some unsaved work.', // FIXME: Requires translation
    });

    this.setDirty = function() {
        isDirty = true;
    };

    this.setClean = function() {
        isDirty = false;
    };

    this.onInputChange = function() {
        this.trigger('formChanged');
    };

    this.showWarningMessage = function(e) {
        if (isDirty) {
            e = e || window.event;
            e.returnValue = this.attr.exitMessage;

            return this.attr.exitMessage;
        }
    };

    this.after('initialize', function() {
        this.on(window, 'beforeunload', this.showWarningMessage);
        this.on('asyncFormSuccess', this.setClean);
        this.on('autosaveSuccess', this.setClean);
        this.on('formChanged', this.setDirty);
        this.on('click', {
            submitSelector: this.setClean,
        });
        this.on('change', {
            inputSelector: this.onInputChange,
        });
    });
}

export default defineComponent(FormChangeTracker);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/form-change-tracker.js